export const fullSizeAbsoluteStyle = `
  position: absolute !important;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;